<div [ngSwitch]="templateId"
     [ngClass]="{ 'pointer': routerLink != null }">
  <div *ngIf="percent !== null"
       [ngClass]="[
    'full-width v2-h-4px bg-surface-variant v2-radius-8px full-height'
  ]">
    <div [ngClass]="[
      'v2-h-4px v2-h-4px v2-radius-8px',
      'v2-w-' + percent + 'pct',
      percent <= 25 ? 'bg-chart-3' : 'bg-chart-1'
    ]"></div>
  </div>

  <ng-container *ngSwitchCase="'LABEL_FIRST-HEAVY-A'">
    <div [routerLink]="routerLink"
         class="flex-column-start-start">
      <div class="label-m"
           [ngClass]="[secondaryTextColor]">{{label}}
        <span *ngIf="tooltip"
              [cTip]="tooltip">
          <fa-icon [icon]="['far', 'question-circle']"> </fa-icon>
        </span>
      </div>
      <div class="flex-row-start-end"
           [ngClass]="[primaryTextColor]">

        <a7-moving-number class="label-xl"
                          [number]="value"
                          [decimalPlaceClass]="smallerDecimal ? 'label-m-pro' : ''">
        </a7-moving-number>

        <div *ngIf="supplementary"
             class="label-xs margin-l-spacing-in-component-m"
             [ngClass]="[supplementaryTextColor, !valueHasDecimal ? 'padding-v-spacing-in-component-m': '']">
          {{supplementary}}</div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngSwitchCase="'LABEL_FIRST-XHEAVY-A'">
    <div [routerLink]="routerLink"
         class="full-width full-height v2-min-h-10 bg-surface-container-low border-radius-4px v2-padding-16px v2-row-gap-12px flex-column-start-start">
      <div class="label-sm"
           [ngClass]="[secondaryTextColor]">{{label}}
        <span *ngIf="tooltip"
              [cTip]="tooltip">
          <fa-icon [icon]="['far', 'question-circle']"> </fa-icon>
        </span>
      </div>
      <div class="flex-row-start-end"
           [ngClass]="[primaryTextColor]">
        <a7-moving-number class="numeric-lg"
                          [number]="value">
        </a7-moving-number>
        <div *ngIf="supplementary"
             class="label-xs margin-l-spacing-in-component-m"
             [ngClass]="[supplementaryTextColor]">
          {{supplementary}}</div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngSwitchCase="'LABEL_FIRST-LIGHT-A'">
    <div [routerLink]="routerLink"
         class="flex-column-start-start">
      <div class="label-sm"
           [ngClass]="[secondaryTextColor]">{{label}}</div>
      <div class="flex-row-start-end v2-margin-2px-t"
           [ngClass]="[primaryTextColor]">
        <div class="label-md">{{value}}</div>
        <div *ngIf="supplementary"
             class="label-xs margin-l-spacing-in-component-m"
             [ngClass]="[supplementaryTextColor]">
          {{supplementary}}</div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngSwitchCase="'LABEL_FIRST-MEDIUM-A'">
    <div [routerLink]="routerLink"
         class="flex-column-start-start">
      <div class="label-m"
           [ngClass]="[secondaryTextColor]">{{label}}
        <span *ngIf="tooltip"
              [cTip]="tooltip">
          <fa-icon [icon]="['far', 'question-circle']"> </fa-icon>
        </span>
      </div>
      <div class="flex-row-start-end"
           [ngClass]="[primaryTextColor]">
        <div class="label-l-pro">{{value}}</div>
        <div *ngIf="supplementary"
             class="label-xs margin-l-spacing-in-component-m padding-v-spacing-in-component-l"
             [ngClass]="[supplementaryTextColor]">{{supplementary}}</div>
      </div>
    </div>
  </ng-container>


  <ng-container *ngSwitchCase="'VALUE_FIRST-HEAVY-A'">
    <div class="flex-column-start-start">
      <div class="flex-row-start-end"
           [ngClass]="[primaryTextColor]">
        <a7-moving-number class="label-xl"
                          [number]="value"
                          [decimalPlaceClass]="smallerDecimal ? 'label-m-pro' : ''">
        </a7-moving-number>
        <div *ngIf="supplementary"
             class="label-m-pro margin-l-spacing-in-component-m"
             [ngClass]="[supplementaryTextColor, !valueHasDecimal ? 'padding-v-spacing-in-component-m': '']">
          {{supplementary}}</div>
      </div>
      <div class="label-m v2-margin-2px-t"
           [ngClass]="[secondaryTextColor]">{{label}}
        <span *ngIf="tooltip"
              [cTip]="tooltip">
          <fa-icon [icon]="['far', 'question-circle']"> </fa-icon>
        </span>
      </div>
    </div>
  </ng-container>

  <ng-container *ngSwitchCase="'VALUE_FIRST-MEDIUM-A'">
    <ng-container *ngTemplateOutlet="valueFirstMedium">
    </ng-container>
  </ng-container>

  <ng-container *ngSwitchCase="'VALUE_FIRST-MEDIUM-B'">
    <ng-container *ngTemplateOutlet="valueFirstMedium">
    </ng-container>
  </ng-container>

  <ng-container *ngSwitchCase="'VALUE_FIRST-LIGHT-A'">
    <div class="flex-column-start-start">
      <div class="flex-row-start-center"
           [ngClass]="[primaryTextColor]">
        <div class="label-s">{{value}}</div>
      </div>
      <div class="label-xs"
           [ngClass]="[secondaryTextColor]">{{label}}
        <span *ngIf="tooltip"
              [cTip]="tooltip">
          <fa-icon [icon]="['far', 'question-circle']"> </fa-icon>
        </span>
      </div>
    </div>
  </ng-container>
  <ng-container *ngSwitchCase="'COMPACT-MEDIUM-A'">
    <div class="full-width flex-row-between-center v2-col-gap-8px text-right">
      <div class="label-m"
           [ngClass]="[secondaryTextColor]">{{label}}
        <span *ngIf="tooltip"
              [cTip]="tooltip">
          <fa-icon [icon]="['far', 'question-circle']"> </fa-icon>
        </span>
      </div>
      <div class="flex-row-start-center"
           [ngClass]="[primaryTextColor]">
        <div class="label-m-pro">{{value}}</div>
      </div>
    </div>
  </ng-container>


  <ng-container *ngSwitchCase="'CHIP-LIGHT-A'">
    <div class="padding-v-spacing-in-component-xs inline-block">
      <div class="bg-surface-container-high label-xs border-radius-xxs padding-h-spacing-in-component-m padding-v-spacing-in-component-xs"
           [ngClass]="[secondaryTextColor]">{{label}} {{value}}
      </div>
    </div>
  </ng-container>

  <ng-container *ngSwitchCase="'CHIP-LIGHT-B'">
    <div class="padding-v-spacing-in-component-xs inline-block">
      <div class="bg-tertiary-container label-xs border-radius-xxs padding-h-spacing-in-component-m padding-v-spacing-in-component-xs"
           [ngClass]="['color-on-tertiary-container']">{{label}} {{value}}
      </div>
    </div>
  </ng-container>
</div>

<ng-template #valueFirstMedium>
  <div [ngClass]="variant ==='A' ? 'flex-column-start-center' : 'flex-column-start-start'">
    <div class="flex-row-start-end"
         [ngClass]="[primaryTextColor]">
      <div class="label-l-pro">{{value}}</div>
      <div *ngIf="supplementary"
           class="label-xs margin-l-spacing-in-component-s padding-v-spacing-in-component-m">{{supplementary}}</div>
    </div>
    <div class="label-m"
         [ngClass]="[secondaryTextColor]">{{label}}
      <span *ngIf="tooltip"
            [cTip]="tooltip">
        <fa-icon [icon]="['far', 'question-circle']"> </fa-icon>
      </span>
    </div>
  </div>
</ng-template>
